<template>
  <div id="lotacoes">
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="top-menu" v-bind:class="{ fixed: isFixed }">
      <div class="container">
        <div class="top-menu-content">
          <div class="logo">
            <img
              v-if="
                $store.state.infoMunicipio != null &&
                $store.state.infoMunicipio.logotipo != ''
              "
              :src="$store.state.infoMunicipio.logotipo"
              class="logo"
              alt="êSUS Feedback"
            />
            <h3>{{ $store.state.cidade }}</h3>
          </div>
          <div class="options-user">
            <ul>
              <li>
                <a
                  href=""
                  title="Aumentar fonte"
                  v-on:click.prevent.stop="aumentarFonte()"
                  >A+</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Diminuir fonte"
                  v-on:click.prevent.stop="diminuirFonte()"
                  >A-</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Alto contraste"
                  v-on:click.prevent.stop="adjust()"
                >
                  <i class="icofont-adjust"></i>
                </a>
              </li>
              <li>
                <a href="#" v-on:click.prevent.stop="">
                  <i class="icofont-user-alt-7"></i>
                  <h3 class="name-user">
                    {{ nome }}
                  </h3>
                  <i class="icofont-caret-down"></i>
                </a>
                <ul class="second-level-menu user-menu">
                  <li v-on:click.prevent.stop="logout()">
                    <a href="#"> <i class="icofont-logout"></i> Sair</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <a
      v-if="exibeBtnWhatsapp"
      href="https://api.whatsapp.com/send?phone=5583996801291"
      target="_blank"
      class="btn-whatsapp"
    >
      <i class="icofont-whatsapp"></i>
    </a> -->
    <div class="lotacoes-items">
      <div class="container main">
        <div class="row">
          <div class="col-12">
            <h3>Escolha um acesso para continuar:</h3>
          </div>
          <div class="col-12">
            <b-card
              no-body
              class="overflow-hidden lotacao-item"
              v-for="(item, index) in lotacoes"
              :key="index"
              @click="selecionarLotacao(item)"
            >
              <b-row no-gutters>
                <b-col md="12">
                  <b-card-body>
                    <b-card-text>
                      <i class="icofont-google-map"></i>
                      {{ $store.state.cidade }} <br />
                      <strong>Equipe</strong> {{ item.no_equipe }} <br />
                      <strong>INE</strong> {{ item.ine_equipe }}</b-card-text
                    >
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <b-modal
      ref="my-modal"
      title="Atenção!"
      @ok="handleOk"
      ok-title="Continuar"
      cancel-title="Voltar"
      id="modal-lotacoes"
    >
      <div class="d-block text-center">
        <p>
          O INE do acesso escolhido é diferente da equipe que você está
          lotado(a). Deseja continuar assim mesmo?
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Footer from '@/components/Footer'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'EscolherAcesso',
  components: {
    Footer,
    PulseLoader,
  },
  data() {
    return {
      lotacoes: [],
      isFixed: false,
      selectedItem: null,
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  mounted() {
    this.buscarLotacoes()
  },
  computed: {
    nome() {
      var arr = this.$store.state.username.split(' ')
      if (arr.length > 1) {
        var keep = arr[1][0]?.toUpperCase() != arr[1][0]
        return arr.slice(0, keep ? 3 : 2).join(' ')
      } else {
        return arr[0]
      }
    },
    exibeLogo() {
      if (this.$store.state.infoMunicipio?.exibe_logoefb == '1') {
        return true
      }
      return false
    },
    exibeBtnWhatsapp() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['logout']),

    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },

    async buscarLotacoes() {
      try {
        this.loading = true
        const response = await this.$apiPublic.get(
          '/auth/lotacoes/' +
            this.$store.state.cod_ibge +
            '/' +
            this.$route.params.nu_cpf
        )
        this.lotacoes = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    handleOk() {
      // this.$store.commit('setNuCns', this.selectedItem.nu_cns)
      this.$store.commit('setNuIne', this.selectedItem.ine_equipe)
      this.$store.commit('setNuCnes', this.selectedItem.nu_cnes)
      this.$router.push('/dashboard')
    },

    selecionarLotacao(item) {
      this.selectedItem = item
      if (item.ine_equipe != item.ine_profissional && item.fam_cbo != '2232') {
        this.showModal()
      } else {
        // this.$store.commit('setNuCns', item.nu_cns)
        this.$store.commit('setNuIne', item.ine_equipe)
        this.$store.commit('setNuCnes', item.nu_cnes)
        this.$router.push('/dashboard')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#lotacoes {
  .lotacoes-items {
    h3 {
      margin-bottom: 20px;
    }
    .lotacao-item {
      margin-bottom: 10px;
      cursor: pointer;
      padding: 5px !important;
      .card-body {
        padding: 15px !important;
      }
      &:hover {
        border: 2px solid;
      }
    }
  }
}
</style>

<style>
#modal-lotacoes .btn.btn-primary {
  background-color: green !important;
  border-color: green !important;
  color: #fff !important;
}
#modal-lotacoes .btn.btn-secondary {
  background-color: white !important;
  border-color: #000 !important;
  color: #000 !important;
}
</style>
